import { CalendarOutlined, UserOutlined } from "@ant-design/icons";
import { Col, Image, Row } from "antd";
import React, { useEffect } from "react";
import Layout from "../shared/Layout/Layout";
import NewSidebar from "../shared/Sidebar/NewSidebar/NewSidebar";
import PageIntro from "../shared/PageIntro/PageIntro";
import Video from "../shared/Video/Video";

function NewsDetails() {
  const data = [
    {
      NewsImage: "/newsDetailsImage.svg",
    },
    {
      NewsImage: "/newsDetailsImage.svg",
    },
    {
      NewsImage: "/newsDetailsImage.svg",
    },
  ];

  useEffect(() => {
    document.title = "News Details - MetaWorldX";
  }, []);

  return (
    <Layout>
      <div className="mt-[60px]">
        <>
          <PageIntro
            headingOne={"News Details"}
            headingTwo={
              "Home < 3DCS Returns To Startup Roots With MIP Partnership"
            }
          />
        </>
        <div className="px-12 py-8 max-[481px]:px-0">
          <Row gutter={[30, 8]}>
            <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
              <NewSidebar />
            </Col>
            <Col xs={24} sm={24} md={24} lg={16} xl={16} xxl={16}>
              <div className="text-[34px] text-[#ffffff] font-semibold max-[481px]:text-[18px] px-2">
                3DCS Returns To Startup Roots With MIP Partnership
              </div>
              <div className="text-lg text-[#ffffff] font-semibold max-[481px]:text-[12px] mt-2 px-2">
                3D CityScapes got its start with McMaster Innovation Factory’s
                help.
              </div>

              <div className="flex max-[481px]:px-2">
                <span className="flex items-center text-[#ffffff]">
                  <CalendarOutlined />
                  &nbsp; August 3, 2021
                </span>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <span className="flex items-center text-[#ffffff]">
                  <UserOutlined />
                  &nbsp; Admin
                </span>
              </div>
              <div className="mt-8">
                <Image src="/newsDetails.svg" preview={false} alt="img" />
              </div>

              <div className="mt-4">
                <p className="text-[#ffffff] text-lg max-[481px]:text-[12px] px-2">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting. remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </div>

              <Row gutter={[20, 8]} className="mt-4">
                {data.map((val) => {
                  return (
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
                      <div className=" max-[481px]:flex justify-center">
                        <Image src={val?.NewsImage} preview={false} alt="img" />
                      </div>
                    </Col>
                  );
                })}
              </Row>

              <div className="mt-4">
                <p className="text-[#ffffff] text-lg max-[481px]:text-[12px] px-2">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting. remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </div>

              <div className="mt-4">
                <Video />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
}

export default NewsDetails;
